/*
 * Wishlist drawer line items carry a real product photo now.
 *
 * sat-app.js's wishlistLines builds each row from scratch (id, name, cond,
 * priceLabel, add, remove, open) rather than spreading the full product
 * object the way cartLines does — so it never picked up .photo, and
 * snippets/sat-overlays.liquid fell back to a plain diagonal-stripe swatch
 * for every saved item instead of showing what was actually saved. The
 * photo itself was never missing data, just never attached to this one
 * list — every product object already carries it (see
 * snippets/sat-bootstrap.liquid's "photo" field), so this only needs to
 * look each row's product back up and copy it across.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    if (!Array.isArray(out.wishlistLines) || !out.wishlistLines.length) { return out; }

    var self = this;
    out.wishlistLines = out.wishlistLines.map(function (wl) {
      var p = self._products && self._products.find(function (x) { return x.id === wl.id; });
      if (!p || !p.photo) { return wl; }
      var copy = Object.assign({}, wl);
      copy.photo = p.photo;
      return copy;
    });

    return out;
  };
})();
